import React from 'react';
import Content from './content/Content';
import Header from './header/Header';
import Footer from './footer/Footer';
import Sidebar from './sidebar/Sidebar';
import Framework from 'fw/components/framework/Framework.js';
import ReLogin from 'areas/public/login/ReLogin.js';
import Routes from './routes/Routes';
import { TimeoutControl } from 'fw/components';
import * as App from 'modules/app/App';
import * as Block from 'fw/globals/Block';

import 'css/styles.js';

class MainLayout extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            authenticated: false,
            reloginVisible: false
        }
    }

    componentWillMount() {
		document.body.setAttribute("class", "skin-blue sidebar-mini");
		
		if (!App.isAuthenticated()) {
            this.props.history.push('/public/login');
        }
        else
            this.setState({ authenticated: true });   
    }

	componentDidMount() {
		if (App.isAuthenticated()) {
			// Resize sections on page loading
			window.addEventListener('load', (event) => {
				this.resize();
			});

			// Resize sections on browser window resizing
			window.addEventListener('resize', (event) => {
				this.resize();
			});

			// Run resize in case that load event listener was registered after the page was loaded
			this.resize();
		}
	}

    componentWillUpdate() {
        if (!App.isAuthenticated()) {
            this.props.history.push('/public/login');
            this.setState({ authenticated: false });
        }
    }

	resize = () => {
		var heights = window.innerHeight;
		var heightMenu = document.querySelectorAll(".main-header")[0].offsetHeight;
		var heightFooter = document.querySelectorAll(".main-footer")[0].offsetHeight;

		document.querySelectorAll(".content-wrapper")[0].style.minHeight = heights - heightMenu - heightFooter + "px";  
	}

    onTimeout = () => {
        this.setState({ reloginVisible: true });
    }

    reloginClose = () => {
        this.setState({ reloginVisible: false });
    }

    render() {
        if (!this.state.authenticated)
            return null;

        const sessionTimeout = App.context().sessionTimeout;

        return (
            <React.Fragment>
                <ReLogin visible={this.state.reloginVisible} onClose={this.reloginClose} />
                <TimeoutControl onTimeout={this.onTimeout} minutes={sessionTimeout} />
                <Header />
                <Sidebar />
                <Content>
                    <Framework />
                    <Block.Block ref={Block.hookref}>
                        <Routes match={this.props.match} />
                    </Block.Block>
                </Content>
                <Footer />
            </React.Fragment>);
    }
}

export default MainLayout;



// WEBPACK FOOTER //
// ./src/layouts/main/MainLayout.js